import React, { Component } from 'react';
import Head from '../../../../components/Head/Head';
import Auxiliary from '../../../../hoc/Auxiliary/Auxiliary';
import { withTranslation } from 'react-i18next';
import OutsourcingSecurityBanner from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingSecurity/OutsourcingSecurityBanner/OutsourcingSecurityBanner';
import OutsourcingSecurity2 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingSecurity/OutsourcingSecurity2/OutsourcingSecurity2';
import OutsourcingSecurity3 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingSecurity/OutsourcingSecurity3/OutsourcingSecurity3';
import OutsourcingSecurity4 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingSecurity/OutsourcingSecurity4/OutsourcingSecurity4';
import OutsourcingSecurity5 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingSecurity/OutsourcingSecurity5/OutsourcingSecurity5';
import OutsourcingSecurity6 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingSecurity/OutsourcingSecurity6/OutsourcingSecurity6';
import OutsourcingSecurity7 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingSecurity/OutsourcingSecurity7/OutsourcingSecurity7';

class OutsourcingSecurity extends Component {
    render() {
        return (
            <Auxiliary>
                <Head id="outsourcing-security" />
                <OutsourcingSecurityBanner {...this.props} />
                <OutsourcingSecurity2 {...this.props} />
                <OutsourcingSecurity3 {...this.props} />
                <OutsourcingSecurity4 {...this.props} />
                <OutsourcingSecurity5 {...this.props} />
                <OutsourcingSecurity6 {...this.props} />
                <OutsourcingSecurity7 {...this.props} />
                <div className='custom-end-outsourcing-security'></div>
            </Auxiliary>
        );
    }
}

export default withTranslation()(OutsourcingSecurity);
